import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersBetweenLines } from "@fortawesome/free-solid-svg-icons";
import { useState  } from "react";
import TableComponent from "../../components/TableComponent";


function Committee() {

    const columns = [
        { name: " اسم اللجنة", key: "name" },
        { name: "وصف اللجنة", key: "description" },
      
        { name: "", key: "actions" },
    ];

    const dropdownOptions = [
        { label: "الاعضاء", route: "/committeemembers/:id" },
    ];

    return (
        <>
            <div className="printcasedata-container">
                <TableComponent
                    apiUrl="/associationcommittee"
                    columns={columns}
                    title="تقرير اللجان"
                    titleIcon={<FontAwesomeIcon icon={faUsersBetweenLines} />}
                    dropdownOptions={dropdownOptions}
                    searchDate={false}
                />
            </div>
        </>
    );
}
export default Committee
